import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { BoardSelectListItem } from 'webapp/components/boards/popup-select-list';
import FormCheckboxComponent from 'webapp/components/form/checkbox';
import TableSorterComponent from 'webapp/components/table-sorter';

import type FilterSortBoardAtSelectPopup from 'webapp/models-custom/filter-sort/board-at-select-popup';
import FilterSortBoardFromAnotherSpaceAtSelectPopup from 'webapp/models-custom/filter-sort/board-from-another-space-at-select-popup';
import type FilterSortReportAtSelectPopup from 'webapp/models-custom/filter-sort/report-at-select-popup';

interface Args {
	filterSort:
		| FilterSortBoardAtSelectPopup
		| FilterSortBoardFromAnotherSpaceAtSelectPopup
		| FilterSortReportAtSelectPopup;
	isSelectedAll: boolean;
	checkIfAllItemsCanBeSelected: (items: BoardSelectListItem[]) => boolean;
	onSelectAll: (value: boolean) => void;
	isTableView?: boolean;
	isTeamSection?: boolean;
	hideDatasourceColumn?: boolean;
}

export default class BoardsSelectTableHeaderSorterComponent extends Component<Args> {
	get isFilterForAnotherSpace() {
		return this.args.filterSort instanceof FilterSortBoardFromAnotherSpaceAtSelectPopup;
	}

	@action
	onBeforeSelectAll(): Promise<void> {
		if (this.args.checkIfAllItemsCanBeSelected(this.args.filterSort.results)) {
			return Promise.resolve();
		} else {
			return Promise.reject();
		}
	}
	<template>
		<colgroup>
			<col width="5%" />
			{{#if @isTableView}}
				<col width="10%" />
				{{#if @hideDatasourceColumn}}
					<col width="50%" />
				{{else}}
					<col width="35%" />
					<col width="15%" />
				{{/if}}
				{{#if this.isFilterForAnotherSpace}}
					<col width="20%" />
				{{else}}
					<col width="15%" />
					<col width="10%" />
				{{/if}}
			{{else}}
				<col width="5%" />
				<col width="200" />
				{{! <col width="12%"> }}
				<col />
			{{/if}}
		</colgroup>
		<thead>
			<tr>
				<th class="c0 no-grow">
					<FormCheckboxComponent
						@name="select_all"
						@selected={{@isSelectedAll}}
						@onBeforeChange={{this.onBeforeSelectAll}}
						@onChange={{@onSelectAll}}
					/>
				</th>
				<th class="c1 no-grow">
					<TableSorterComponent
						@selectedProp={{@filterSort.sortProp}}
						@selectedOrder={{@filterSort.sortOrder}}
						@prop="name"
						@name="Name"
						@changeProp={{@filterSort.changeSortProp}}
						@changeOrder={{@filterSort.changeSortOrder}}
					/>
				</th>
				{{#if @isTableView}}
					<th class="c2"></th>
					{{#if this.isFilterForAnotherSpace}}
						<th class="c1 no-grow">
							<TableSorterComponent
								@selectedProp={{@filterSort.sortProp}}
								@selectedOrder={{@filterSort.sortOrder}}
								@prop="accountName"
								@name="Account"
								@changeProp={{@filterSort.changeSortProp}}
								@changeOrder={{@filterSort.changeSortOrder}}
							/>
						</th>
						<th class="c1 no-grow">
							<TableSorterComponent
								@selectedProp={{@filterSort.sortProp}}
								@selectedOrder={{@filterSort.sortOrder}}
								@prop="modified"
								@name="Last modified"
								@changeProp={{@filterSort.changeSortProp}}
								@changeOrder={{@filterSort.changeSortOrder}}
							/>
						</th>
					{{/if}}
					{{#unless @hideDatasourceColumn}}
						<th class="c3 prio-low">
							<TableSorterComponent
								@selectedProp={{@filterSort.sortProp}}
								@selectedOrder={{@filterSort.sortOrder}}
								@prop="sourcesList.length"
								@name="Data sources"
								@changeProp={{@filterSort.changeSortProp}}
								@changeOrder={{@filterSort.changeSortOrder}}
							/>
						</th>
					{{/unless}}
				{{/if}}
				{{#unless this.isFilterForAnotherSpace}}
					<th class="c4 prio-medium">
						<TableSorterComponent
							@selectedProp={{@filterSort.sortProp}}
							@selectedOrder={{@filterSort.sortOrder}}
							@prop="created"
							@name="Date created"
							@changeProp={{@filterSort.changeSortProp}}
							@changeOrder={{@filterSort.changeSortOrder}}
						/>
					</th>
					{{!-- <th class="c5 prio-medium">
                <TableSorter
                    @selectedProp={{@filterSort.sortProp}}
                    @selectedOrder={{@filterSort.sortOrder}}
                    @prop="modified"
                    @name="Modified"
                    @changeProp={{@filterSort.changeSortProp}}
                    @changeOrder={{@filterSort.changeSortOrder}}
                />
            </th> --}}
					<th class="c6 prio-medium">
						<TableSorterComponent
							@selectedProp={{@filterSort.sortProp}}
							@selectedOrder={{@filterSort.sortOrder}}
							@prop="tags.length"
							@name="Tags"
							@changeProp={{@filterSort.changeSortProp}}
							@changeOrder={{@filterSort.changeSortOrder}}
						/>
					</th>
				{{/unless}}
			</tr>
		</thead>
	</template>
}
